import {
    createContext
} from "react";

export const ButtonMediaContext = createContext<boolean>(false);
